
import { useTranslation } from 'react-i18next';
import { Settings, Code2, Workflow, Lightbulb } from 'lucide-react';
import Section from '../ui/Section';

const Services: React.FC = () => {
  const { t } = useTranslation();
  
  const services = [
    {
      icon: <Code2 className="w-8 h-8" />,
      key: 'fullstack',
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: <Settings className="w-8 h-8" />,
      key: 'ai_agents',
      gradient: 'from-primary to-secondary',
    },
    {
      icon: <Workflow className="w-8 h-8" />,
      key: 'automation',
      gradient: 'from-emerald-500 to-teal-500',
    },
    {
      icon: <Lightbulb className="w-8 h-8" />,
      key: 'consulting',
      gradient: 'from-orange-500 to-yellow-500',
    },
  ];
  
  return (
    <Section id="services">
      {/* Header */}
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          {t('services.title')}
        </h2>
        <p className="text-lg text-gray-400 leading-relaxed">
          {t('services.subtitle')}
        </p>
      </div>
      
      {/* Grid */}
      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {services.map((service) => (
          <div
            key={service.key}
            className="relative group bg-white/10 border border-white/10 rounded-2xl p-8 hover:border-primary/50 hover:bg-white/[0.12] transition-all duration-300 hover:shadow-2xl hover:shadow-primary/10 overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-primary/5 to-transparent rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            {/* Icon */}
            <div className={`relative w-14 h-14 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
              <div className="text-white">
                {service.icon}
              </div>
            </div>
            
            {/* Content */}
            <h3 className="text-2xl font-bold mb-3 text-white">
              {t(`services.${service.key}.title`)}
            </h3>
            
            <p className="text-gray-400 leading-relaxed">
              {t(`services.${service.key}.description`)}
            </p>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Services;
